import api from '../../../api';
import { finish, error } from '../../../modules/staff/actions/create';

export function request(dispatch, { userData }) {
    api.post('/staff', userData).then(
        data => dispatch(finish(userData)),
        ({ errors }) => dispatch(error(errors))
    );
}
